export default {
  title: "Achievements",
  description: "Track your wedding planning progress",
  stats: {
    pointsEarned: "Points earned",
    completed: "Completed",
    events: "Events",
    level: "Level",
    unlimited: "Unlimited",
    limited: "Limited",
    pro: "Pro",
    essential: "Essential",
    free: "Free"
  },
  categories: {
    all: "All",
    events: "Events",
    subscription: "Subscription",
    engagement: "Engagement",
    social: "Social"
  },
  ui: {
    points: "points",
    completedOn: "Completed on",
    noAchievements: "No achievements in this category yet.",
    loading: "Loading...",
    error: "Error loading achievements"
  },
  rarity: {
    common: "Common",
    rare: "Rare",
    epic: "Epic",
    legendary: "Legendary"
  },
  achievements: {
    firstGuest: "First Guest",
    firstTask: "First Task",
    budgetSet: "Budget Set",
    firstVendor: "First Vendor",
    planningMaster: "Planning Master",
    organized: "Organized",
    budgetWise: "Budget Wise",
    socialite: "Socialite",
    taskMaster: "Task Master",
    timeKeeper: "Time Keeper"
  },
  titles: {
    "Premier Pas": "First Step",
    "Organisateur Multi-événements": "Multi-Event Organizer",
    "Maître des Célébrations": "Master of Celebrations",
    "Légende de l'Organisation": "Organization Legend",
    "Cupide du Mariage": "Wedding Greedy",
    "Roi de la Fête": "Party King",
    "Maître des Fiançailles": "Engagement Master",
    "Spécialiste Baby Shower": "Baby Shower Specialist",
    "Organisateur Spirituel": "Spiritual Organizer",
    "Maître de Tous les Arts": "Master of All Arts",
    "Utilisateur Fidèle": "Loyal User",
    "Expert Premium": "Premium Expert",
    "Liberté Illimitée": "Unlimited Freedom",
    "Supporter de Wedora": "Wedora Supporter",
    "Planificateur Assidu": "Assiduous Planner",
    "Accro à l'Organisation": "Organization Addict",
    Perfectionniste: "Perfectionist",
    "Ambassadeur Wedora": "Wedora Ambassador",
    "Ambassadeur WedBox": "WedBox Ambassador",
    Mentor: "Mentor",
    "Organisateur débutant": "Beginner Organizer",
    "Organisateur confirmé": "Confirmed Organizer",
    "Maître organisateur": "Master Organizer",
    "Premier invité": "First Guest",
    "Mariage intime": "Intimate Wedding",
    "Grande célébration": "Grand Celebration",
    "Planificateur économe": "Thrifty Planner",
    "Gestionnaire avisé": "Wise Manager",
    "Expert financier": "Financial Expert",
    "Chroniqueur débutant": "Beginner Chronicler",
    "Maître du temps": "Time Master",
    "Bienvenue !": "Welcome!",
    "C'est parti !": "Let's Go!",
    "Supporter de WedBox": "WedBox Supporter"
  },
  descriptions: {
    firstGuest: "Add your first guest to the list",
    firstTask: "Create your first task",
    budgetSet: "Set your wedding budget",
    firstVendor: "Add your first vendor",
    planningMaster: "Complete 50% of your tasks",
    organized: "Create 10 tasks",
    budgetWise: "Stay within 90% of your budget",
    socialite: "Add 50 guests",
    taskMaster: "Complete 20 tasks",
    timeKeeper: "Create your timeline",
    "Créez votre premier événement": "Create your first event",
    "Gérez 3 événements différents": "Manage 3 different events",
    "Créez 5 événements différents": "Create 5 different events",
    "Gérez 10 événements ou plus": "Manage 10 or more events",
    "Organisez votre premier mariage": "Organize your first wedding",
    "Organisez 3 anniversaires": "Organize 3 birthdays",
    "Organisez une cérémonie de fiançailles": "Organize an engagement ceremony",
    "Organisez un baby shower": "Organize a baby shower",
    "Organisez un baptême": "Organize a baptism",
    "Organisez au moins un événement de chaque type": "Organize at least one event of each type",
    "Passez au plan Essential": "Upgrade to Essential plan",
    "Passez au plan Pro": "Upgrade to Pro plan",
    "Profitez des événements illimités du plan Pro": "Enjoy unlimited events with Pro plan",
    "Restez abonné pendant 3 mois": "Stay subscribed for 3 months",
    "Connectez-vous 7 jours consécutifs": "Log in 7 consecutive days",
    "Connectez-vous 30 jours consécutifs": "Log in 30 consecutive days",
    "Complétez 100% des tâches d'un événement": "Complete 100% of an event's tasks",
    "Partagez votre expérience sur les réseaux sociaux": "Share your experience on social media",
    "Aidez un autre utilisateur avec vos conseils": "Help another user with your advice",
    "Complétez 5 tâches": "Complete 5 tasks",
    "Complétez 15 tâches": "Complete 15 tasks",
    "Complétez 50 tâches": "Complete 50 tasks",
    "Ajoutez votre premier invité": "Add your first guest",
    "Ajoutez 20 invités": "Add 20 guests",
    "Ajoutez 100 invités": "Add 100 guests",
    "Créez votre premier budget": "Create your first budget",
    "Ajoutez 5 dépenses": "Add 5 expenses",
    "Restez dans les limites de votre budget": "Stay within your budget limits",
    "Ajoutez votre premier événement au planning": "Add your first event to the schedule",
    "Planifiez tous les événements importants": "Plan all important events",
    "Créez votre compte Wedora": "Create your Wedora account",
    "Créez votre compte WedBox": "Create your WedBox account",
    "Complétez l'onboarding": "Complete onboarding"
  },
  rewards: {
    points: "{{points}} points",
    badge: "Badge earned",
    unlock: "Feature unlocked"
  },
  earnedPoints: "Points earned",
  pointsCount: "{{earned}} / {{total}}",
  points: "{{count}} point",
  points_one: "{{count}} point",
  points_other: "{{count}} points",
  completedAt: "Completed on {{date}}",
  unlocked: "Achievement unlocked!",
  continue: "Continue",
  empty: {
    title: "No achievements",
    description: "No achievements in this category yet."
  }
};
